import { useStyles } from "./RCALibraryNumberExpandedCell.styles";
import ActionPlanIcon from "pages/Corporate/RCA/images/action_plan_icon.svg";
import { IRCALibraryNumberExpandedCell } from "./RCALibraryNumberExpandedCellInterfaces";
import { useTranslation } from "react-i18next";

const RCALibraryNumberExpandedCell = ({ actionPlan }: IRCALibraryNumberExpandedCell) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <div className={classes.descriptionWrapper}>
            <img src={ActionPlanIcon} alt="Action plan icon" />
            <span>{`${t("rca.ap")}-${actionPlan.action_plan_id}`}</span>
        </div>
    );
};

export default RCALibraryNumberExpandedCell;
